import React, { Component } from "react";
import { Modal, Button, Icon } from 'antd';

const styles = {
    title: { fontSize: "24px", fontWeight: "bold", color: "#0f2747", marginTop: "20px", lineHeight: 1.2 },
    subtitle: { color: "#5b6b7f", marginBottom: "20px" },
    label: { fontWeight: "bold", color: "#0f2747", marginBottom: "6px" },
    input: {
        width: "100%",
        height: "40px",
        padding: "0 12px",
        border: "1px solid #c9d3e3",
        borderRadius: "6px",
        backgroundColor: "#f3f6fc",
        fontSize: "20px",
        outline: "none",
    },
    error: { color: "red", marginTop: "6px" },
    button: {
        marginTop: "20px",
        height: "40px",
        borderRadius: "6px",
        backgroundColor: "#163a63",
        borderColor: "#163a63",
        color: "#fff",
        fontWeight: "bold",
    },
    back: { display: "inline-block", marginTop: "16px", color: "#0b64c9", fontWeight: "bold", cursor: "pointer", fontSize: "20px" },
    resultIconBox: {
        position: "relative",
        width: "160px",
        height: "130px",
        margin: "0 auto",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    resultBadge: {
        position: "absolute",
        top: "-16px",
        right: "-16px",
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        border: "3px solid #fff",
        color: "#fff",
        fontSize: "20px",
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    resultTitle: { fontSize: "18px", fontWeight: "bold", color: "#0f2747", marginTop: "20px" },
    resultDescription: { color: "#5b6b7f", marginTop: "8px" },
    resultNote: { marginTop: "16px", padding: "10px 16px", borderRadius: "6px", fontSize: "12px" },
};

const RESULTS = {
    // Reset link was emailed to the user directly
    "0201": {
        iconColor: "#3b5bdb",
        iconBackground: "#e3eaf8",
        badgeColor: "#2f9e44",
        badge: <Icon type="check" />,
        title: "Password reset link sent",
        description: ["A password reset link has been sent to your registered email.", "Please check your email to continue."],
        note: "If you cannot find it, check Spam / Junk Email.",
        noteStyle: { backgroundColor: "#eef1fa", color: "#0f2747", fontSize: "16px" },
    },
    // Request was forwarded to the admin for approval
    "0202": {
        iconColor: "#e8773a",
        iconBackground: "#fde8db",
        badgeColor: "#e8773a",
        badge: "!",
        title: "Password reset request sent",
        description: ["Your request has been sent to your Admin for review.", "Please wait for the admin to send the reset link."],
        note: "You will receive the reset link by email after approval.",
        noteStyle: { backgroundColor: "#fdeee4", color: "#9a4a12",fontSize: "16px", fontWeight: "bold" },
    },
};

export default class ForgotPasswordModal extends Component {
    constructor(props) {
        super(props);
        this.state = { username: "", errormessage: "" };
        this.handleContinue = this.handleContinue.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose() {
        this.setState({ username: "", errormessage: "" });
        this.props.onCancel();
    }

    handleContinue() {
        const username = this.state.username.trim();
        if (!username) {
            this.setState({ errormessage: "Please enter your username." });
            return;
        }
        this.props.onContinue(username);
    }

    renderResult(result) {
        return (
            <div style={{ textAlign: "center", paddingTop: "12px" }}>
                <div style={{ ...styles.resultIconBox, backgroundColor: result.iconBackground }}>
                    <Icon type="mail" className="forgot-password-result-icon" style={{ color: result.iconColor }} />
                    <div style={{ ...styles.resultBadge, backgroundColor: result.badgeColor }}>{result.badge}</div>
                </div>
                <div style={styles.resultTitle}>{result.title}</div>
                <div style={styles.resultDescription}>
                    {result.description[0]}
                    <br />
                    {result.description[1]}
                </div>
                <div style={{ ...styles.resultNote, ...result.noteStyle }}>{result.note}</div>
                <a style={{ ...styles.back, fontSize: "20px" }} onClick={this.handleClose}>
                    <Icon type="left" style={{ marginRight: "6px" }} />Back to Log in
                </a>
            </div>
        );
    }

    render() {
        const { visible, logo, loading, resultCode } = this.props;
        const message = this.state.errormessage || this.props.errormessage;
        const { username } = this.state;
        const result = RESULTS[resultCode];
        return (
            <Modal
                visible={visible}
                footer={null}
                closable={false}
                centered
                width={result ? 480 : 420}
                onCancel={this.handleClose}
                bodyStyle={{ padding: "28px 32px" }}
                maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.25)" }}
            >
                {result ? this.renderResult(result) : (<>
                {logo && <img src={logo} alt="logo" style={{ maxWidth: "120px" }} />}
                <div style={styles.title}>Forgot Password</div>
                <div style={styles.subtitle}>Enter your username to continue.</div>
                <div style={styles.label}>Username</div>
                <input
                    type="text"
                    name="username"
                    placeholder="Username"
                    style={styles.input}
                    value={username}
                    onChange={(e) => this.setState({ username: e.target.value, errormessage: "" })}
                    onKeyPress={(e) => { if (e.key === "Enter") this.handleContinue(); }}
                />
                {message && <div style={styles.error}>{message}</div>}
                <Button block loading={loading} onClick={this.handleContinue} style={styles.button}>
                    Continue
                </Button>
                <a style={styles.back} onClick={this.handleClose}>
                    <Icon type="left" style={{ marginRight: "6px" }} />Back to Log in
                </a>
                </>)}
            </Modal>
        );
    }
}
